import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";
import VanRentalSteps from "../components/van-rental-dubai/VanRentalSteps";
import VanRentalSubsections from "../components/van-rental-dubai/VanRentalSubsections";
import VanRentalFleet from "../components/van-rental-dubai/VanRentalFleet";

import { vanRentalDubaiSections } from "../components/van-rental-dubai/vanRentalDubaiSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";

const VanRentalInDubai = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "vr-hero":
        return (
          <ContactHero
            key={index}
            variant="van-rental"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "vr-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            compact={section.compact}
          />
        );

      case "vr-steps":
        return (
          <VanRentalSteps
            key={index}
            title={section.title}
            description={section.description}
            steps={section.steps}
          />
        );

      case "vr-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "vr-subsections":
        return (
          <VanRentalSubsections
            key={index}
            title={section.title}
            intro={section.intro}
            subsections={section.subsections}
          />
        );

      case "vr-fleet":
        return (
          <VanRentalFleet
            key={index}
            title={section.title}
            description={section.description}
            stats={section.stats}
          />
        );

      case "vr-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Refrigerated Van Rental in Dubai &amp; Fujairah | Chiller Fleet Transport</title>
        <meta name="description" content="Refrigerated van rental in Dubai & Fujairah for chilled and frozen cargo. Self-drive or with driver, daily to monthly terms, same-day dispatch. Book today." />
        <link rel="canonical" href="https://chillerfleet.com/van-rental-in-dubai" />
        <meta property="og:title" content="Refrigerated Van Rental in Dubai & Fujairah | Chiller Fleet Transport" />
        <meta property="og:description" content="Refrigerated van rental in Dubai & Fujairah for chilled and frozen cargo. Self-drive or with driver, daily to monthly terms, same-day dispatch. Book today." />
        <meta property="og:url" content="https://chillerfleet.com/van-rental-in-dubai" />
        <meta name="twitter:title" content="Refrigerated Van Rental in Dubai & Fujairah | Chiller Fleet Transport" />
        <meta name="twitter:description" content="Refrigerated van rental in Dubai & Fujairah for chilled and frozen cargo. Self-drive or with driver, daily to monthly terms, same-day dispatch. Book today." />
      </Helmet>

      {vanRentalDubaiSections.map(renderSection)}
    </>
  );
};

export default VanRentalInDubai;
